<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f u-ac u-jsb " :inline="true">
                <div>
                    <el-form-item label="模糊搜索">
                        <el-input v-model="titles" placeholder="请输入内容" clearable size="small"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" @click="synchro">同步</el-button>
                    </el-form-item>
                    <el-form-item label="专栏">
                        <el-select v-model="zl_value" placeholder="请选择" size="small">
                            <el-option v-for="item in zl_options" :key="item.id" :label="item.name" :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="title" label="直播名称" show-overfl ow-tooltip> </el-table-column>
                <el-table-column prop="title" label="状态" show-overfl ow-tooltip>
                    <template slot-scope="{row}">
                        {{({0:'未开始',1:'正在直播',2:'结束'})[row.status]}}
                    </template>
                </el-table-column>
                 <el-table-column prop="title" label="回放" show-overfl ow-tooltip>
                    <template slot-scope="{row}">
                        {{({1:'是',2:'否'})[row.playback ]}}
                    </template>
                </el-table-column>
                <el-table-column prop="live_broadcast" label="直播地址" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="start_time" label="直播时间" show-overflow-tooltip width="180"> </el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 设置 -->
        <el-dialog title="直播设置" :visible.sync="dialoged" top="80px" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="forms" :model="forms" label-width="140px" :rules="formsrules" class="demo-ruleForm">
                    <el-form-item label="直播名称" prop="zs_value">
                        <el-input size="small" v-model="forms.zs_value"></el-input>
                    </el-form-item>
                    <el-form-item label="直播连接地址" prop="problem">
                        <el-input size="small" v-model="forms.problem"></el-input>
                    </el-form-item>
                    <el-form-item label="展示用户">
                        <el-select v-model="forms.audience_type" placeholder="请选择" size="small">
                            <el-option v-for="item in show_user_options" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="直播时间" prop="start_time">
                        <el-date-picker v-model="forms.start_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间" size="small">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="forms.live_states" placeholder="请选择" size="small">
                            <el-option v-for="item in live_states_options" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否回放">
                        <el-radio-group v-model="forms.playback ">
                            <el-radio :label="2">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading='subloading' @click="submited('forms')" size="small">确 定</el-button>
                <el-button @click="dialoged = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                resource_id: 'p_5fdb0346e4b0231ba88d4839',
                resource_type: '4',
                dialog: false,
                titles: '',
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 10,
                count: 0,
                heights: null,

                // 
                eid: '',
                dialogs: false,
                zs_options: [],
                form: {
                    zs_value: '',
                    textareas: '',
                    audience_type: 0,
                    live_states: 0
                },

                dialoged: false,
                forms: {
                    problem: '',
                    zs_value: '',
                    audience_type: 0,
                    live_states: 0,
                    start_time: '',
                    playback: 2
                },
                listItem: [],
                arrxq: '',
                show_user_options: [{
                        id: 0,
                        name: '全部'
                    },
                    {
                        id: 1,
                        name: '用户'
                    }, {
                        id: 2,
                        name: '医生'
                    },
                ],
                live_states_options: [{
                        id: 0,
                        name: '未开始'
                    },
                    {
                        id: 1,
                        name: '正在直播'
                    },
                    {
                        id: 2,
                        name: '结束'
                    },
                ],
                zl_value: 'p_618229ffe4b00bdc7c76dbe4',
                zl_options: [{
                        id: 0,
                        code: 'p_618229ffe4b00bdc7c76dbe4',
                        name: '专业医师手术现场直播'
                    },
                    {
                        id: 1,
                        code: 'p_5fdb0346e4b0231ba88d4839',
                        name: '焕活新生，轻松做男人'
                    }, {
                        id: 2,
                        code: 'p_6185e313e4b02561a6ca0765',
                        name: '男科会议直播'
                    }, {
                        id: 3,
                        code: 'p_6188d6b7e4b09b5fe0b1593d',
                        name: '中医讲堂'
                    },
                ],
                formsrules: {
                    zs_value: [{
                        required: true,
                        message: '请填写直播标题',
                        trigger: 'blur'
                    }],
                    problem: [{
                        required: true,
                        message: '请填写直播连接地址',
                        trigger: 'blur'
                    }],
                    start_time: [{
                        required: true,
                        message: '请填写直播开始时间',
                        trigger: 'blur'
                    }],
                },
                subloading: false,
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            // that.getxx()
            that.getHeight()
            that.begin()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 200 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 200 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 10
                that.search()
            },
            //同步
            synchro() {
                let that = this
                axios
                    .post("/admin/KkysXiaoet/UpdateColumnList", {
                        goods_id: that.zl_value,
                        goods_type: that.resource_type,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.tableData = response.data.data.data

                        that.search()
                    })
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/KkysXiaoet/getLocalColumnList", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        goods_id: that.zl_value,


                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.data
                        that.count = response.data.data.total

                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            // 新增
            add() {
                let that = this
                that.dialoged = true
                that.eid = '0'
                that.forms.problem = ''
            },
            // 设置
            submited(formName) {
                let that = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.subloading = true
                        axios
                            .post("/admin/KkysXiaoet/updateLocalColumn", {
                                id: that.eid,
                                live_broadcast: that.forms.problem,
                                audience_type: that.forms.audience_type,
                                title: that.forms.zs_value,
                                status: that.forms.live_states,
                                start_time: that.forms.start_time,
                                playback: that.forms.playback,


                            }, {
                                token: true
                            })
                            .then(res => {
                                if (res.data.code == 200) {
                                    this.$message.success('操作成功！')
                                    that.dialoged = false
                                    that.search()
                                } else {
                                    this.$message(res.data.msg)
                                }
                                this.subloading = false
                            })
                            .catch(error => {
                                this.subloading = false
                            })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
            handleEdit(index, row) {
                let that = this
                that.dialoged = true
                that.eid = row.id
                that.forms.zs_value = row.title
                that.forms.problem = row.live_broadcast
                that.forms.audience_type = row.audience_type
                that.forms.live_states = row.status
                that.forms.start_time = row.start_time
                that.forms.playback = row.playback

            },

        },

    };
</script>


<style scoped>
    .imgs {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 5px;
    }

    .lefts {
        max-height: 500px;
        overflow: auto;
    }

    .delt {
        color: red;
        font-size: 20px;
    }

    .blues {
        color: #409eff;
    }

    .concon {
        background: #f5f5f5;
        padding: 10px;
        border-radius: 10px;
    }
</style>